import React, { useEffect, useState, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import Breadcrumb from "../../components/breadcrumb";

import { createPortal } from "react-dom";

Schedulernew.propTypes = {};

function Schedulernew(props) {
  const [toggle, setToggle] = useState({ key: "", status: false });
  const [isShowMobile, setShowMobile] = useState(false);
  const navigate = useNavigate();

  const handleToggle = (key) => {
    if (toggle.key === key) setToggle({ status: false });
    else setToggle({ status: true, key });
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({ live: false });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);

  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(null);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
    fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort");
      setCategories(res.data);
    } catch {}
  };
  const fetchCategoriesnew = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort");
      setCategoriesnew(res.data);
    } catch {}
  };
  const fetchCategoriesnew1 = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort");
      setCategoriesnew1(res.data);
    } catch {}
  };
  const fetchCategoriesnew2 = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort");
      setCategoriesnew2(res.data);
    } catch {}
  };

  const { bookingId } = useParams();
  
  const API_BASE = "https://adhigyanam-e92bf1bbbdb1.herokuapp.com";

   // Fetch booking + reserve slot
  useEffect(() => {
    const fetchBookingAndReserve = async () => {
      setBookingLoading(true);
      setBookingError(null);
      try {
        const res = await axios.get(`${API_BASE}/bookingdetailshmkr/${bookingId}`);
        if (res.data && res.data.success && res.data.data) {
          const bookingData = res.data.data;

          // Step 2: Reserve slot automatically
          const reserveRes = await axios.post(`${API_BASE}/reserve-slot-hmkr`, {
            booking_id: bookingData.Id,
          });

          if (reserveRes.data.success) {
            setBookingSuccess(true);
            // Redirect after 2s delay
            setTimeout(() => {
              navigate(`/userdetails_hmkr_new/${reserveRes.data.reservationId}`);
            }, 2000);
          } else {
            setBookingError(reserveRes.data.message || "Failed to reserve slot.");
          }
        } else {
          setBookingError("Invalid booking details.");
        }
      } catch (err) {
        console.error("Error:", err);
        setBookingError("Failed to process booking.");
      } finally {
        setBookingLoading(false);
      }
    };

    if (bookingId) fetchBookingAndReserve();
  }, [bookingId, navigate]);


  return (
    <>
      <Helmet>
        <title>Please Wait - Adhigyanam</title>
      </Helmet>
<div className="menu-mobile-popup">
              <div className="modal-menu__backdrop" onClick={handleMobile}></div>
              <div className="widget-filter">
                <div className="mobile-header">
                  <div id="logo" className="logo">
                    <Link to="/home">
                      <img className="site-logo" src={logo} alt="Image" />
                    </Link>
                  </div>
                  <Link className="title-button-group" onClick={handleMobile}>
                    <i className="icon-close"></i>
                  </Link>
                </div>

               <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
                <div className="header-customize-item button" style={{padding: "0px 0px",
          background:"none",
          backgroundColor:"#14a077",
          borderRadius: "4px",
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "21px",
          color: "white",
          borderColor: "transparent",
          textTransform: "capitalize"}}>
                  <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
                </div>
                <div className="header-customize-item button">
                  <Link to="/login">My Account</Link>
                </div>

                 <div className="mobile-footer">
                  <div className="icon-infor d-flex aln-center">
                    <div className="icon">
                      <span className="icon-call-calling">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                      </span>
                    </div>
                    <div className="content">
                      <p>Need help? 24/7</p>
                      <h6>
                         <Link to={`tel:918960708425`}>+91-8960708425</Link>
                      </h6>
                    </div>
                  </div>
                  <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
                  <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
                  <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
            <ul className="list-social d-flex aln-center">
                                           <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                           <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                           <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                       </ul>
          </div>
                </div>
              </div>
            </div>
      <Header2 />
      <Breadcrumb title="Please Wait" />

          {/* Main Section */}
      <div style={{ textAlign: "center", marginTop: "120px", minHeight: "300px" }}>
        {bookingLoading ? (
          <>
            <div
              className="spinner-border text-success"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            ></div>
            <p style={{ color: "#333", fontSize: "16px" }}>
              Please Wait! Processing your booking...
            </p>
          </>
        ) : bookingError ? (
          <p style={{ color: "red", fontWeight: 500 }}>{bookingError}</p>
        ) : null}
      </div>

      <Footer />
      {/* <Gotop /> */}
    </>
  );
}

export default Schedulernew;